<script>


import {headerState} from "@/stores/headerStore.js";
import EnrollTrainingModal from "@/components/trainings/EnrollTrainingModal.vue";

export default {
    components: {EnrollTrainingModal},
    data() {
        return {
            training: null,
            loading: true,
            modalOpened: false
        }
    },
    methods: {
        getTraining() {
            axios.get('/trainings/' + this.$route.params.id + '/thumbnail').then((response) => {
                this.training = response.data.data;
                if (this.training.is_enrolled) {
                    this.$router.push({name: this.training.is_series ? 'training-series.show' : 'trainings.show', params: {id: this.$route.params.id}});
                    return;
                }
                headerState.title = this.training.name;
                this.modalOpened = true;
            }).catch(() => {
            }).finally(() => {
                this.loading = false;
            })
        },
        onClose() {
            this.$router.push({name: 'trainings.my'})
        }
    },
    async mounted() {
        if (this.$route.query?.code) {
            await this.$auth.loginByTrainingCode(this.$route.query.code, {name: 'trainings.enroll', params: {id: this.$route.params.id}});
            this.getTraining();
        } else if (this.$auth.isLoggedIn()) {
            this.getTraining();
        } else {
            this.$router.push({ name: 'login' });
        }

    },
    beforeUnmount() {
    }
}

</script>
<template>
    <div class="trainings-enroll">

        <loader :loading="loading"></loader>

        <div v-if="!loading && training">
            <div class="mb-4 training-description">
                {{ training.description }}
            </div>
        </div>

        <EnrollTrainingModal
            v-if="modalOpened"
            :showDescription="true"
            @onEnroll="onClose"
            @onClose="onClose"
            :training="training" />
    </div>
</template>

<style scoped>
    .training-description {
        white-space: pre-line;
    }
</style>
